import type { SVGProps } from 'react';
const SvgBagSuitcase1StreamlineCore = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="-0.75 -0.75 20 20" {...props}>
    <desc>{'Bag Suitcase 1 Streamline Icon: https://streamlinehq.com'}</desc>
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
      <path d="M4.625 8.92h9.25M4.625 12.884h9.25M15.857 4.625H2.643c-.73 0-1.322.592-1.322 1.321v9.911c0 .73.592 1.322 1.322 1.322h13.214c.73 0 1.322-.592 1.322-1.322v-9.91c0-.73-.592-1.322-1.322-1.322" />
      <path d="M12.554 4.625V2.643a1.32 1.32 0 0 0-1.322-1.322H7.268a1.32 1.32 0 0 0-1.322 1.322v1.982" />
    </g>
  </svg>
);
export default SvgBagSuitcase1StreamlineCore;
